import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFile, faPhone, faCheckCircle, faPen, faLightbulb, faPaperPlane } from "@fortawesome/free-solid-svg-icons";

const WorkflowSection = () => {
  const steps = [
    {
      title: "Initial Consultation",
      description: "We discuss your project requirements and understand your goals.",
      icon: faPhone,
      color: "text-green-500"
    },
    {
      title: "Proposal Submission",
      description: "We send a detailed proposal outlining the scope, timeline, and pricing.",
      icon: faFile,
      color: "text-yellow-500"
    },
    {
      title: "Agreement & Payment",
      description: "Once approved, we proceed with agreement signing and payment.",
      icon: faCheckCircle,
      color: "text-orange-500"
    },
    {
      title: "Implementation",
      description: "Our team works on your project, ensuring quality and accuracy.",
      icon: faLightbulb,
      color: "text-purple-500"
    },
    {
      title: "Draft & Review",
      description: "We provide a draft for your review and incorporate feedback.",
      icon: faPen,
      color: "text-pink-500"
    },
    {
      title: "Delivery",
      description: "Final delivery of your project within the agreed timeframe.",
      icon: faPaperPlane,
      color: "text-blue-500"
    }
  ];

  return (
    <div id="workflow" className="py-16 bg-gradient-to-br from-yellow-200 via-yellow-300 to-yellow-100">
      <h2 className="text-5xl font-bold text-center mb-12 text-gray-800">
        How Our New Workflow Works
      </h2>

      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10 px-4">
        {steps.map((step, index) => (
          <div key={index} className="flex flex-col items-center text-center relative">
            <div className={`w-16 h-16 flex items-center justify-center rounded-full border-2 ${step.color} mb-4`}>
              <FontAwesomeIcon icon={step.icon} className="text-2xl" />
            </div>
            <h3 className="text-xl font-semibold mb-2">{step.title}</h3>
            <p className="text-gray-600">{step.description}</p>

            {/* Dotted arrow lines */}
            {index < steps.length - 1 && (
              <div className="hidden md:block absolute top-8 right-[-50%] w-1/2 border-t-2 border-dotted border-grey-700"></div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default WorkflowSection;
